<ion-modal
  [isOpen]="isModalOpen$ | async"
  (ionModalDidDismiss)="dismissModal()"
  [class]="
    (platformService?.isTouchExperience$ | async)
      ? 'ion-modal-touch'
      : 'modal-desktop-size-xl'
  "
  [initialBreakpoint]="
    platformService?.platformType !== platformService?.platformEnum.desktop
      ? 1
      : undefined
  "
  [breakpoints]="
    platformService?.platformType !== platformService?.platformEnum.desktop
      ? [0, 1]
      : undefined
  "
>
  <ng-template>
    <app-modal-with-nav-inline
      [rootPage]="modalRef"
      [rootPageParams]="{
        selectedProducts: selectedProducts,
        list: list,
        platform: platform,
        title: title,
        groups: groups,
        dismissFunc: dismissModal,
        selectedGroup: selectedGroup,
        listItems: listItems,
        getListData: getListData,
        getListsLoaded: getLoaded,
        finalSubmission,
        enableCopyToList,
        hideCopyToListOption,
      }"
    >
    </app-modal-with-nav-inline>
  </ng-template>
</ion-modal>
